var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
	var $toggleButton = $('.js_toggleMenu');
    var $drawerWraper = $('.header .menu');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('touchstart click', function(e) {
        e.preventDefault();
        
        $drawerWraper.toggleClass('is_open');
        $(this).toggleClass('is_open');
        $('body').toggleClass('locked');

        setMobileMenuHeight();
    });
}


// Toogle SubMenu
//-----------------------------------------------------------------
mp.subMenuToggle = function() {
    var $toggleButton = $('.header .menu .have-submenu');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('mouseenter', function(e) {
        e.preventDefault();
        $('body').addClass('submenu-opened');
        $(this).addClass('active');
    }).on('mouseleave', function(e) {
        e.preventDefault();
        $('body').removeClass('submenu-opened');
        $(this).removeClass('active');
    });
}


// Set Mobile Menu Height
//-----------------------------------------------------------------
function setMobileMenuHeight(){

    var $drawerWraper = $('.header .menu');     
    
    var _vph = $(window).height();
    var _vpw = $(window).width();

    if (_vpw < 1024) {
        $drawerWraper.css('min-height', _vph - 80);
    } else {
        $drawerWraper.removeClass('is_open').removeAttr('style');
        $('.js_toggleMenu').removeClass('is_open');
        $('body').removeClass('locked');
    }
}


$(document).ready(function(){
    mp.MenuToggle();
    mp.subMenuToggle();
});